import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export function ZInput({ label, error, help, id, type, ...props }) {
  const [show, setShow] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword ? (show ? "text" : "password") : type;
  const toggleTestId = `${props["data-testid"] || "password"}-toggle`;
  return (
    <div style={{ marginBottom: 14 }}>
      {label && <label className="z-label" htmlFor={id}>{label}</label>}
      <div style={{ position: "relative" }}>
        <input
          id={id}
          type={inputType}
          className="z-input"
          style={isPassword ? { paddingRight: 44 } : undefined}
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShow((s) => !s)}
            aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
            data-testid={toggleTestId}
            tabIndex={-1}
            style={{
              position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)",
              background: "none", border: "none", cursor: "pointer", padding: 6,
              color: "var(--z-muted)", display: "flex", alignItems: "center",
            }}
          >
            {show ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        )}
      </div>
      {help && !error && <p className="z-help">{help}</p>}
      {error && <p className="z-error-text">{error}</p>}
    </div>
  );
}

export function ZTextarea({ label, error, help, id, ...props }) {
  return (
    <div style={{ marginBottom: 14 }}>
      {label && <label className="z-label" htmlFor={id}>{label}</label>}
      <textarea id={id} className="z-textarea" {...props} />
      {help && !error && <p className="z-help">{help}</p>}
      {error && <p className="z-error-text">{error}</p>}
    </div>
  );
}

export function ZSelect({ label, error, help, id, children, ...props }) {
  return (
    <div style={{ marginBottom: 14 }}>
      {label && <label className="z-label" htmlFor={id}>{label}</label>}
      <select id={id} className="z-select" {...props}>{children}</select>
      {help && !error && <p className="z-help">{help}</p>}
      {error && <p className="z-error-text">{error}</p>}
    </div>
  );
}

export default ZInput;
